import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as moment from "moment";
import Select from "react-select";

import "../datatables.scss";
import { getCalendarEvents } from "store/actions";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";

import "@fullcalendar/bootstrap/main.css";

// Add custom CSS for calendar header
const calendarStyles = `
  @media (max-width: 767px) {
    .fc .fc-toolbar {
      display: flex !important;
    }
    .fc .fc-toolbar-title {
      position: absolute !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      font-size: 1.2em !important;
    }
  }
`;

const clubs = [
  { value: "1", label: "San Francisco" },
  { value: "2", label: "Oakland" },
  { value: "3", label: "San Rafael" },
  { value: "4", label: "Los Angeles" },
];

function renderEventContent(eventInfo) {
  const { eventData, isMobile } = eventInfo.event.extendedProps;

  let startTime = "";
  if (eventData.isHoliday) {
    return (
      <div
        style={{
          backgroundColor: "#28a745",
          color: "white",
          borderRadius: "0px",
          fontSize: "14px",
          fontWeight: "500",
          textAlign: "center",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          lineHeight: "16px",
          height: "16px",
        }}
      >
        {eventData.title}
      </div>
    );
  }
  if (eventData?.startTime) {
    startTime = moment(eventData.startTime, "HH:mm:ss").format("hh:mm A");
  } else {
    startTime = moment(eventData.start_time, "HH:mm:ss").format("hh:mm A");
  }

  let endTime = "";
  if (eventData?.endTime) {
    endTime = moment(eventData.endTime, "HH:mm:ss").format("hh:mm A");
  } else {
    endTime = moment(eventData.end_time, "HH:mm:ss").format("hh:mm A");
  }

  return isMobile ? (
    <div
      style={{
        height: 10,
        width: 10,
        borderRadius: 10,
        marginBottom: 5,
        backgroundColor: eventInfo.event.backgroundColor,
      }}
    ></div>
  ) : (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        borderRadius: 10,
        padding: 10,
        boxShadow: "0 0 8px rgba(0, 0, 0, 0.15)",
        maxHeight: "100px",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <div
          style={{
            height: 10,
            width: 10,
            borderRadius: 10,
            backgroundColor: eventInfo.event.backgroundColor,
          }}
        ></div>
        <div
          style={{
            fontWeight: "600",
            fontSize: 14,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={eventInfo.event.title}
        >
          {eventInfo.event.title}
        </div>
      </div>

      <div style={{ fontSize: 12, marginTop: 5, whiteSpace: "nowrap" }}>
        {startTime} - {endTime}
      </div>

      <div
        style={{
          fontSize: 12,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        title={eventData?.location}
      >
        {eventData?.location}
      </div>

      <div
        style={{
          fontSize: 12,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        title={eventData?.cmNeeded}
      >
        {eventData?.cmNeeded}
      </div>

      {eventData?.cleanerNeeded && (
        <div style={{ fontSize: 20, marginTop: 2 }}>🧹</div>
      )}
    </div>
  );
}

class PublicEvents extends Component {
  constructor(props) {
    super(props);
    this.calendarComponentRef = React.createRef();

    this.state = {
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      modal: false,
      selectedDate: null,
      selectedClub: "1",
      holidayEvents: [],
    };
  }

  componentDidMount() {
    fetch(
      "https://date.nager.at/api/v3/PublicHolidays/" +
        new Date().getFullYear() +
        "/US"
    )
      .then((res) => res.json())
      .then((data) => {
        const holidayEvents = data.map((h) => ({
          id: `hol-${h.date}`,
          title: h.localName,
          start: h.date,
          allDay: true,
          className: "fc-us-holiday",
          isHoliday: true,
        }));
        this.setState({ holidayEvents });
      })
      .catch((err) => {
        console.error("Failed to load holidays:", err);
      });

    const styleSheet = document.createElement("style");
    styleSheet.innerText = calendarStyles;
    document.head.appendChild(styleSheet);

    const {
      match: { params },
      onGetCalendarEvents,
    } = this.props;
    if (params && params.clubId) {
      this.setState({ selectedClub: params.clubId });
      onGetCalendarEvents(params.clubId);
    }
  }

  componentWillUnmount() {
    const styles = document.querySelectorAll("style");
    styles.forEach((style) => {
      if (style.innerText === calendarStyles) {
        style.remove();
      }
    });
  }

  handleClubChange = (selectedOption) => {
    const clubId = selectedOption.value;
    this.setState({ selectedClub: clubId });
    this.props.history.push(`/public/events/${clubId}`);
    this.props.onGetCalendarEvents(clubId);
  };

  toggleModal = () => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };

  handleEventClick = (event) => {
    this.setState({
      modal: true,
      selectedDate: event.event.start,
    });
  };

filterEventsByClub = (events) => {
  const { selectedClub } = this.state;

  return events.filter((item) => {
    // Normalize all possibilities into an array of numbers
    let clubArray = [];

    if (Array.isArray(item.clubIds)) {
      clubArray = item.clubIds.map(Number);
    } else if (typeof item.clubIds === "string") {
      clubArray = item.clubIds.split(",").map((v) => Number(v));
    } else if (item.clubId) {
      clubArray = [Number(item.clubId)];
    }

    return clubArray.includes(Number(selectedClub));
  });
};

  render() {
    const { loadingCalendarEvents, calendarEvents } = this.props;
    const { selectedClub } = this.state;

    const filteredEvents = this.filterEventsByClub(calendarEvents);

    return (
      <React.Fragment>
        <div style={{ paddingTop: 20 }}>
          <MetaTags>
            <title>
              {clubs.find((club) => club.value === selectedClub)?.label} Events |
              Groundfloor
            </title>
          </MetaTags>
          <div className="container-fluid">
            <div
              className="mb-4"
              style={{ maxWidth: "200px", position: "relative", zIndex: 2 }}
            >
              <Select
                value={clubs.find((club) => club.value === selectedClub)}
                onChange={this.handleClubChange}
                options={clubs}
                isSearchable={false}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "45px",
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 3,
                    backgroundColor: "white",
                  }),
                }}
              />
            </div>

            <Row>
              <Col className="col-12">
                <Card style={{ position: "relative", zIndex: 1 }}>
                  <CardBody>
                    <Col className="col-lg-12">
                      <FullCalendar
                        eventClick={this.handleEventClick}
                        height="auto"
                        style={{ width: "100%" }}
                        eventContent={renderEventContent}
                        ref={this.calendarComponentRef}
                        plugins={[
                          BootstrapTheme,
                          dayGridPlugin,
                          interactionPlugin,
                        ]}
                        handleWindowResize={true}
                        themeSystem="bootstrap"
                        initialView="dayGridMonth"
                        headerToolbar={{
                          left: "prev,next today",
                          center: "title",
                          right: "",
                        }}
                        eventSources={[
                          {
                            events: this.state.holidayEvents.map((item) => ({
                              id: item.id,
                              title: item.title,
                              eventData: item,
                              start: item.start,
                              end: item.start,
                              backgroundColor: "#28a745",
                              isHoliday: item.isHoliday,
                              isEvent: true,
                              allDay: item.allDay,
                            })),
                            borderColor: "#28a745",
                          },
                          {
                            events: filteredEvents.map((item) => ({
                              id: item.id,
                              title: item.title,
                              eventData: item,
                              start:
                                moment(item?.startDate)
                                  .utc()
                                  .format("YYYY-MM-DD") + `T${item.startTime}`,
                              end:
                                moment(item?.startDate)
                                  .utc()
                                  .format("YYYY-MM-DD") + `T${item.endTime}`,
                              backgroundColor: "lightgreen",
                              isMobile: this.state.isMobile,
                            })),
                          },
                        ]}
                      />
                    </Col>

                    {loadingCalendarEvents && (
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: "50%",
                          zIndex: 100,
                        }}
                      >
                        <i className="bx bx-loader bx-spin font-size-48 align-middle me-2 bx-lg" />
                      </div>
                    )}
                  </CardBody>
                </Card>

                <Modal size="sm" isOpen={this.state.modal}>
                  <ModalHeader toggle={this.toggleModal}></ModalHeader>
                  <ModalBody>
                    <FullCalendar
                      height={600}
                      eventContent={renderEventContent}
                      ref={this.calendarComponentRef}
                      plugins={[
                        BootstrapTheme,
                        dayGridPlugin,
                        interactionPlugin,
                      ]}
                      handleWindowResize={true}
                      themeSystem="bootstrap"
                      initialView="dayGridDay"
                      headerToolbar={{
                        left: "",
                        center: "title",
                        right: "",
                      }}
                      initialDate={this.state.selectedDate}
                      events={filteredEvents.map((item) => ({
                        id: item.id,
                        title: item.title,
                        eventData: item,
                        start:
                          moment(item?.startDate).utc().format("YYYY-MM-DD") +
                          `T${item.startTime}`,
                        end:
                          moment(item?.startDate).utc().format("YYYY-MM-DD") +
                          `T${item.endTime}`,
                        backgroundColor: "lightgreen",
                      }))}
                    />
                  </ModalBody>
                </Modal>
              </Col>
            </Row>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

PublicEvents.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object.isRequired,
  loadingCalendarEvents: PropTypes.bool,
  calendarEvents: PropTypes.array,
  onGetCalendarEvents: PropTypes.func,
};

const mapStateToProps = ({ events }) => ({
  calendarEvents: events.calendarEvents,
  loadingCalendarEvents: events.loadingCalendarEvents,
});

const mapDispatchToProps = (dispatch) => ({
  onGetCalendarEvents: (id) => dispatch(getCalendarEvents(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PublicEvents));
